import { BrowserRouter, Route, Routes } from 'react-router';
import './App.css';
import { Container } from 'components/common/Container';
import { MainPage } from 'components/pages/MainPage';
import { LegalInfoPage } from 'components/pages/LegalInfoPage';

function App() {
	return (
		<div className='App'>
			<Container>
				<BrowserRouter>
					<Routes>
						<Route index element={<MainPage />} />
						<Route path='/legalInfo' element={<LegalInfoPage />} />
					</Routes>
				</BrowserRouter>
			</Container>
		</div>
	);
}

export default App;
